import { Box, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import PropTypes, { string } from 'prop-types';
import LineList from '../atoms/LineList';
import clsx from 'clsx';

export default function DescriptionDetails({ activities, title, withoutBorder, paddingTop }) {
  const useStyles = makeStyles((theme) => ({
    activities: {
      borderBottom: `0.6px solid ${theme.palette.gray.lightGray}`,
      paddingBottom: '16px'
    },
    titleList: {
      padding: '16px 0',
      paddingTop: paddingTop,
      textTransform: 'upperCase',
      color: theme.palette.gray.midGray,
      fontSize: '14px',
      fontWeight: 700,
    },
    whitoutBorder: {
      border: 'none'
    }
  }))

  const classes = useStyles();

  const justOne = activities.length <= 0 ? [''] : activities

  return (
    <Box className={clsx(classes.activities, withoutBorder ? classes.whitoutBorder : '')}>
      <Typography variant={'body1'} component="h2" className={classes.titleList}>
        {title}
      </Typography>
      {justOne.map((activity, i) => (
        <LineList description={activity} key={Number((activities.length * activity.length) + i)} isOdd={(i % 2 === 0)} />
      ))}
    </Box>
  )
}

DescriptionDetails.propTypes = {
  activities: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
  withoutBorder: PropTypes.bool,
  paddingTop: PropTypes.string.isRequired
}

DescriptionDetails.defaultProps = {
  withoutBorder: false,
}
